export default "__VITE_ASSET__AAG4VQyF__"